/* eslint-disable import/named */
import { actionCreator } from 'utils';
import * as ReprintTypes from '../types/reprintTypes';

// L O A D   P R E P R E S S
export function loadReprint() {
    return {
        type: ReprintTypes.LOAD_REPRINT,
    };
}

export function loadReprintRes(data) {
    return {
        type: actionCreator(ReprintTypes.LOAD_REPRINT, 'res'),
        data,
    };
}

export function loadReprintErr() {
    return {
        type: actionCreator(ReprintTypes.LOAD_REPRINT, 'err'),
    };
}
// L O A D   P R E P R E S S

// S E T   P R E P R E S S   F I L T E R
export function setReprintFilters(key, value) {
    return {
        type: ReprintTypes.SET_REPRINT_FILTERS,
        key,
        value,
    };
}

export function setReprintPagination(key, pagination) {
    return {
        type: ReprintTypes.SET_REPRINT_PAGINATION,
        key,
        pagination,
    };
}

export function setReprintSort(key, type) {
    return {
        type: ReprintTypes.SET_REPRINT_SORT,
        sort: {
            key,
            type,
        },
    };
}

export function resetReprintFilters() {
    return {
        type: ReprintTypes.RESET_REPRINT_FILTERS,
    };
}
// S E T   P R E P R E S S   F I L T E R S

// T O G G L E   F O R M   P R E P R E S S
export function toggleReprintStatus(data, load) {
    return {
        type: ReprintTypes.TOGGLE_REPRINT_STATUS,
        data,
        load,
    };
}
// T O G G L E   F O R M   P R E P R E S S

export function checkOrderItems(payload) {
    return {
        type: ReprintTypes.CHECK_ORDER_ITEMS,
        payload,
    };
}

export function ignoreReprint(id, quantity) {
    return {
        type: ReprintTypes.IGNORE_REPRINT,
        id,
        quantity,
    };
}

export function ignoreReprintRes() {
    return {
        type: actionCreator(ReprintTypes.IGNORE_REPRINT, 'res'),
    };
}

export function ignoreReprintErr() {
    return {
        type: actionCreator(ReprintTypes.IGNORE_REPRINT, 'err'),
    };
}

